import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable, retry } from 'rxjs';
import { MainService } from 'src/app/app.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AnalysisDetailsService {

  constructor(private _http: HttpClient, private mainService: MainService) { }

  apiURL = environment.QUERY_ANALYZER_V2_API

  getAnalysisByID(id: string): Observable<any> {
      let analysis = this._http.get<any>(this.apiURL + '/analysis/' + id, this.mainService.httpOptions).pipe(
        retry(3),
        map((analysis: any) => {
          analysis["created_at"] = this.getFormattedDate(analysis["created_at"]);
          analysis["updated_at"] = this.getFormattedDate(analysis["updated_at"]);
          return analysis;
        }),
        catchError(this.mainService.handleError)
      );
  
      return analysis;
    }
    
  analyzeWithAI(id: string): Observable<any> {
    let suggestion = this._http.post<any>(this.apiURL + '/analysis/' + id + '/ai', null, this.mainService.httpOptions).pipe(
      retry(3),
      map((suggestion: any) => {
        return suggestion;
      }),
      catchError(this.mainService.handleError)
    );
    return suggestion;
  }

  downloadAnalysis(id: string): Observable<any> {
    const httpOptions = {
      ...this.mainService.httpOptions,
      responseType: 'blob' as 'json'
    };
    
    return this._http.get(this.apiURL + '/analysis/download/' + id, httpOptions).pipe(
      retry(3),
      catchError(this.mainService.handleError)
    );
  }

  getFormattedDate(inputDate) {
    const date = new Date(inputDate);

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const year = date.getFullYear();

    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    const formattedDate = `${day}/${month}/${year} - ${hours}:${minutes}:${seconds}`;
    return formattedDate
  }


}
